export default {
  data() {
    return {
      assignment: null,
      recordingType: 'assignment',
    };
  },
  computed: {
    currentMode: {
      cache: false,
      get() {
        return (this.$store.getters.currentMode) ?
          this.$store.getters.currentMode : null;
      }
    },
    preferences: {
      cache: false,
      get() {
        return this.$store.getters.preferences;
      }
    },
  },
  methods: {
    loadCurrentModeFromPreferences() {
      if (this.assignmentsEnabled) {
        let prefMode = (this.preferences && this.preferences.currentMode) ?
          this.preferences.currentMode : null;
        const defaultMode = this.isGroupManager ? 'manager' : 'speaker';

        // check for closed accounts
        if (this.$store.getters.activeGroups && !this.$store.getters.activeGroups.length &&
        !this.isOrgLevelAdmin && !this.isOrgLevelManager) {
          return this.$store.dispatch('setCurrentMode', 'speaker').then(
            () => {
              if (this.$route.name !== 'subscription' && this.$route.name !== 'confirm-code') {
                this.$router.push({name: 'subscription'});
              }
            }
          );
        }

        // check prefMode and currentMode
        if ((prefMode === 'speaker' || this.currentMode == 'speaker') && !this.isSpeaker) {
          return this.changeMode('manager');
        } else if ((prefMode === 'manager' || this.currentMode == 'manager') && !this.isGroupManager) {
          return this.changeMode('speaker');
        } else if (
          ((prefMode === 'speaker' || this.currentMode == 'speaker') && this.$route.name === 'coach-dashboard') ||
          ((prefMode === 'manager' || this.currentMode == 'manager') && this.$route.name === 'speaker-dashboard')
        ) {
          return this.changeMode(defaultMode);
        }

        if (prefMode && this.currentMode && prefMode == this.currentMode) {
          // no-op
        } else if (prefMode && this.currentMode && prefMode != this.currentMode) {
          this.$store.dispatch('setCurrentMode', this.preferences.currentMode);
        } else if (prefMode && !this.currentMode) {
          this.$store.dispatch('setCurrentMode', this.preferences.currentMode);
        } else if (!prefMode && this.currentMode) {
          // Update the preferences store
          this.$store.dispatch(
            'updatePreferences',
            Object.assign(this.preferences, {currentMode: this.currentMode})
          );
        } else {
          this.changeMode(defaultMode);
        }
      }
    },
    _changeMode(newMode) {
      if (!newMode || (newMode !== 'manager' && newMode !== 'speaker')) {
        newMode = (this.currentMode === 'manager') ? 'speaker' : 'manager';
      }

      const promises = [
        this.$store.dispatch(
          'updatePreferences',
          Object.assign(this.preferences, {currentMode: newMode})
        ),
        this.$store.dispatch('setCurrentMode', newMode)
      ];

      // Update the preferences store
      window.Promise.all(promises).then(() => {
        const destination = (newMode === 'manager') ? 'coach-dashboard' : 'speaker-dashboard';
        if (this.$route.name !== destination && this.$route.name !== 'subscription' && this.$route.name !== 'confirm-code') {
          this.$router.push({name: destination});
        }

        this.$nextTick(() => {
          // Re-render the Navbar
          if (this.navRef) {
            this.navRef += 1;
          }
          this.$forceUpdate();
        });
      });
    },
    changeMode(newMode) {
      // We need throttling to fix a bug where mode switching runs twice from the
      // coach dashboard only. We need to resort to a global variable below cuz
      // Vue resets component data each run, possibly due to the Navbar refreshing
      if (window.isChangeModeThrottled) return;
      window.isChangeModeThrottled = true;
      this._changeMode(newMode);
      window.setTimeout(() => window.isChangeModeThrottled = false, 500);
    }
  }
};
